export type FsvCarouselCardType = "menu";

type TrackFsvCarouselCardClickArgs = {
  cardType: FsvCarouselCardType;
  listingId?: string;
};

export function trackFsvCarouselCardClick({
  cardType,
  listingId,
}: TrackFsvCarouselCardClickArgs) {
  if (typeof window === "undefined") return;
  if (!listingId) return;
  const analytics = window.analyticsIntegrations;
  if (!analytics?.trackEvent) return;
  analytics.trackEvent("fsv carousel card clicked", {
    listing_id: listingId,
    card_type: cardType,
    source: "full_service_carousel",
  });
}
